import { doGet, doPut } from 'src/api/client';

export async function reqGetPlugins() {
  return doGet(`plugins`);
}

export async function reqPutPluginData(key, entityId, data) {
  return doPut(`plugins/${key}?entity_id=${entityId}`, data);
}
